
import styled from 'styled-components';

import { StyledFloatingToolbarBar } from '../common/FloatingToolbar.styled';

const StyledNodeControls = styled(StyledFloatingToolbarBar)(
  ({ top, left }) => `
  z-index: 5;
  top: ${top || 0}px;
  left: ${left || 0}px;
`,
);

export { StyledNodeControls };
